import React, { useState, useContext, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Input, Row, Card, Select } from 'antd';
import PageContainer from '../../../CSIComponents/PageContainer';
import { isEditStateContext, isSaveContext } from '../../../../store/editableContext'
import { post, getData } from '../apiCalls'

declare global {
  interface Window {
    otherAmenitiesGeneralRoom: boolean,
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    },
    otherAmenitiesGeneral: {
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string
    }
  }
}

const GeneralRoomAmenity = () => {

  const [RoomEntrance, setRoomEntrance] = useState('')
  const [AirFiltration, setAirFiltration] = useState('')
  const [HypoallergenicRoom, setHypoallergenicRoom] = useState('')
  const [HousekeepingType, setHousekeepingType] = useState('')
  const [HousekeepingFrequency, setHousekeepingFrequency] = useState('')
  const [HouskeepingDailyFee, setHouskeepingDailyFee] = useState('')
  const [form] = Form.useForm();
  const { Option } = Select;
  const context = useContext(isEditStateContext)
  const saveContext = useContext(isSaveContext)
  const [rateProperties] = useState<string[]>([
    'Yes', 
    'No'
  ]) 
  const [roomEntrance] = useState<string[]>([
    'Interior', 
    'Exterior',
    'Both'
  ]) 
  const [housekeepingType] = useState<string[]>([
    'Full', 
    'Limited'
  ]) 
  const [housekeepingFrequency] = useState<string[]>([
    'Daily', 
    'Weekly'
  ]) 
  const [ready, setReady] = useState<boolean>(false)

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const saveAction = async () => {
    const body = {
      "roomentrance": RoomEntrance,
      "airfilter": AirFiltration,
      "hypoallergicroom": HypoallergenicRoom,
      "housekeepingtype": HousekeepingType,
      "housekeepingfrequency": HousekeepingFrequency,
      "housekeepingdailyfee": HouskeepingDailyFee
    }
    window.otherAmenitiesGeneral = body
    await post()
    await getData()
  }

  useEffect(() => {
    // adding listeners
    const get = async () => {
      setRoomEntrance(window.otherAmenityGet.roomentrance)
      setAirFiltration(window.otherAmenityGet.airfilter)
      setHypoallergenicRoom(window.otherAmenityGet.hypoallergicroom)
      setHousekeepingType(window.otherAmenityGet.housekeepingtype)
      setHousekeepingFrequency(window.otherAmenityGet.housekeepingfrequency)
      setHouskeepingDailyFee(window.otherAmenityGet.housekeepingdailyfee)
      setReady(true)
    }
    get()
  },[])

  useEffect(() => {
    if (saveContext) {
      saveAction()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saveContext])

  useEffect(() => {
    if (context) {
      // removing action buttons
      const buttons: any = document.getElementsByClassName('ligthButton')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.add('d-none')
      }
    }
  },[context])

  useEffect(() => {
    function validation() {
      const onlyFloats = /(\d*\.\d+),?/
      if (HouskeepingDailyFee === null
        || HouskeepingDailyFee === ''  
        || onlyFloats.test(HouskeepingDailyFee)) {
        return window.otherAmenitiesGeneralRoom = true
      }
      return window.otherAmenitiesGeneralRoom = false
    }
    validation()
  },[HouskeepingDailyFee])

  return (
    <>
      { ready ?
        <Card style={{ margin: '16px' }}>
          <Grid container spacing={0} className="containerSpacing py-0">
            <Grid item xs={12} className="p-0">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>General Room Amenity</div>
                  <div className={context ? 'd-none' : ''}>
                    <Button 
                      style={{ background: '#004771', color: '#fff', width: 60, height: 28 }} 
                      onClick={() => { window.editFunction() }}>
                        Edit
                      </Button>
                  </div>
              </div>
            </Grid>
            <Grid item xs={12} className={!context ? "pb-0 px-0 my-0 is-disabled-fields" : "pb-0 px-0 my-0"}>
              <Form
                layout="vertical"
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  "RoomEntrance": RoomEntrance,
                  "AirFiltration": AirFiltration, 
                  "HypoallergenicRoom": HypoallergenicRoom,
                  "HousekeepingType": HousekeepingType,
                  "HousekeepingFrequency": HousekeepingFrequency,
                  "HouskeepingDailyFee": HouskeepingDailyFee
                }}
              >
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      name='RoomEntrance'
                      label="Room Entrance">
                      <Select allowClear onChange={(e: string) => setRoomEntrance(e)}
                        showSearch
                      >
                        {
                          roomEntrance.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='AirFiltration'
                      label="Air Filtration">
                      <Select allowClear onChange={(e: string) => setAirFiltration(e)}
                        showSearch
                      >
                        {
                          rateProperties.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='HypoallergenicRoom'
                      label="Hypoallergenic Room">
                      <Select allowClear onChange={(e: string) => setHypoallergenicRoom(e)}
                        showSearch
                      >
                        {
                          rateProperties.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      name='HousekeepingType'
                      label="Housekeeping Type">
                      <Select allowClear onChange={(e: string) => setHousekeepingType(e)}
                        showSearch
                      >
                        {
                          housekeepingType.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='HousekeepingFrequency'
                      label="Housekeeping Frequency">
                      <Select allowClear onChange={(e: string) => setHousekeepingFrequency(e)}
                        showSearch
                      >
                        {
                          housekeepingFrequency.map((rt: string, index: number) => (
                            <Option value={rt} key={index}>{rt}</Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Houskeeping Daily Fee"
                      key="HouskeepingDailyFee"
                      name="HouskeepingDailyFee"
                      rules={[{ pattern: /^[-+]?[0-9]*\.?[0-9]*$/, message: 'This field should be a number' }]}
                    >
                      <Input
                        onChange={(e: { target: { value: string }}) => setHouskeepingDailyFee(e.target.value)}
                        value={HouskeepingDailyFee} 
                      />
                    </Form.Item>
                  </Col>
                </Row>

              </Form>
            </Grid>
          </Grid>
        </Card>
      : <></>}
    </>
  )
}

export default GeneralRoomAmenity
